export default function CRealLifeExamples() {
  return <h2>C Real Life Examples</h2>;
}
